import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-100 w-100 center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avolta_map = _resolveComponent("avolta-map")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    empty: !_ctx.stations,
    padding: false,
    class: "widget-map"
  }, {
    default: _withCtx(() => [
      (_ctx.stations)
        ? (_openBlock(), _createBlock(_component_avolta_map, {
            key: 0,
            ref: "map",
            stations: _ctx.stationList
          }, null, 8 /* PROPS */, ["stations"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_n_spin, { size: "large" })
          ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["empty"]))
}